import * as React from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function AppToast({ open, message, handleClose, severity }) {
    const handleCloseToast = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        handleClose();
    };

    const Action = () => (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    return (
        <Snackbar
            open={open}
            autoHideDuration={4000}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            onClose={handleCloseToast}
            sx={{ height: '50px' }}
        >
            <Alert
                severity={severity ? severity : 'success'}
                sx={{ width: '100%', padding: '0 5px', alignItems: 'center' }}
            >
                {message} <Action />
            </Alert>
        </Snackbar>
    );
}
